import React from 'react';
import { Input } from 'antd';
import Status from '../status';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const Stepper = ({
  name,
  label,
  type,
  placeholder,
  isRequired = false,
  showError = true,
  min = 0,
  max,
  step = 1,
  ...restProps
}) => (
  <Field name={name}>
    {({ field, meta: { error, touched } }) => {
      const increase = () => {
        const current = Number(field.value) || 0;
        const next = max !== undefined ? Math.min(current + step, max) : current + step;

        field.onChange({
          target: { name: field.name, value: next },
        });
      };

      const decrease = () => {
        const current = Number(field.value) || 0;
        const next = Math.max(current - step, min);

        field.onChange({
          target: { name: field.name, value: next },
        });
      };

      const addonAfter = (
        <div className={style['stepper-buttons']}>
          <button type="button" className={style['stepper-button']} onClick={increase}>
            +
          </button>
        </div>
      );

      const addonBefore = (
        <div className={style['stepper-buttons']}>
          <button type="button" className={style['stepper-button']} onClick={decrease}>
            −
          </button>
        </div>
      );

      return (
        <div className={style['input-wrapper']}>
          {!!isRequired && (
            <p className={style['required-check']}>
              <Status isFilled={!error && !!field?.value} />
            </p>
          )}

          <div className={style['label-box']}>
            <p className={style.label}>{label}</p>

            <div className={style['box']}>
              <Input
                {...field}
                {...restProps}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                status={touched && error ? 'error' : ''}
                type="number"
                className={style.input}
                placeholder={placeholder}
                min={min}
                max={max}
                step={step}
                value={field.value ?? ''}
                onWheel={(e) => e.currentTarget.blur()}
              />
              {touched && error && showError && <p className={style.error}>{error}</p>}
            </div>
          </div>
        </div>
      );
    }}
  </Field>
);

Stepper.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'password', 'number']),
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};

Stepper.defaultProps = {
  type: 'number',
  min: 0,
  step: 1,
};

export default Stepper;
